import React, { useEffect } from 'react'
import Btn from 'components/Btn'
import * as UIcons from '@iconscout/react-unicons'
import { useDispatch, useSelector } from 'react-redux'
import {  showModal } from 'store/slices/miscSlice'
import AddPOS from './AddPOS'
import { withTranslation } from 'react-i18next'
import { POSValidation } from '../validation'
import useSWR, { mutate } from 'swr'
import usePermissions from 'hooks/usePermissions'

export default withTranslation()(function Header({ t, posSetting }) {
  // const {data: stats} = useSWR('pos/get-mobile-app-dashboard-stats')

  const { data: stats } = useSWR('/merchants/stats/total-revenues')
  // const { merchant } = useSelector(state => state.SettingsReducer)
  const dispatch = useDispatch()
  const { response } = useSelector(state => state?.misc)
  // console.log(stats?.data, 'hdhdhdhie');
  const { isPermitted } = usePermissions()
  useEffect(() => { mutate('pos') }, [response])

  return (
    <div className="w-full bg-white p-3 md:p-8 flex flex-col lg:flex-row mb-8 rounded-xl">
      <div className="w-full flex justify-between items-center my-2">
        {isPermitted?.view_pos_revenue ?
          <>
            <div className="col-span-2">
              <h4 className="lg:text-lg xs:text-sm font-semibold md:text-2xl">{stats?.data?.total_revenues}</h4>
              <p className="text-sm">{t('misc.total_revenue')}</p>
            </div>
          </>
          : 'Not permitted'}

        <div className="text-center">
          <h4 className="lg:text-lg xs:text-sm font-semibold md:text-2xl">{stats?.data?.pos_count}</h4>
          <p className="text-sm">{t('pos.pos')}</p>
        </div>

        <div className="col-span-2">
          <h4 className="lg:text-lg xs:text-sm font-semibold md:text-2xl">{stats?.data?.total_transactions}</h4>
          <p className="text-sm">{t('misc.total_transaction')}</p>
        </div>
      </div>

      {posSetting ? (
        <div className="w-full text-right">
          <Btn
            content={() => <><UIcons.UilPlus className="text-white h-5 mr-1" /> <span className="text-white">{t('pos.add')}</span></>}
            className="w-44 h-12 text-white bg-primary rounded-xl"
            disabled={!isPermitted?.create_pos}
            click={() => {
              dispatch(showModal({
                title: t('pos.create'),
                content: AddPOS,
                url: 'pos',
                method: 'post',
                formClass: 'w-11/12 md:w-[390px]',
                validation: POSValidation,
                // extraPayload: { 'user_id': user_Id?.data?.id }
              }))
              // dispatch(getResponse())
            }
            }
          />
        </div>
      ) : (
        null
      )}
    </div>
  )
})